import { cx } from '@emotion/css';
import { useTranslation } from 'next-i18next';

import { Button } from '@phoenix/design-system/frontend/ui/button/button';

export const DeleteConfirmation = ({ onDeleteImage, setShowDeleteConfirmation, className = '', fullWidthButtons = false }) => {
  const { t } = useTranslation('shared');
  const fullWidthClassName = fullWidthButtons ? 'w-full' : undefined;

  return (
    <div className={cx('flex flex-col justify-between gap-6', className)}>
      <div className="flex flex-col justify-center gap-y-2">
        <span className="block stihl-text-h5-desktop">{t('shared_imageUpload_button_delete')}</span>
        <span className="block stihl-text-body-default-reg">{t('shared_deleteImageConfirmation_text')}</span>
      </div>
      <div className="flex gap-x-4">
        <Button
          className={fullWidthClassName}
          containerClassName={fullWidthClassName}
          btnType="grey_default"
          onClick={onDeleteImage}
          data-testid="confirmDelete"
        >
          {t('shared_confirm_button')}
        </Button>
        <Button
          className={fullWidthClassName}
          containerClassName={fullWidthClassName}
          btnType="grey_outline"
          onClick={() => setShowDeleteConfirmation(false)}
          data-testid="cancelDelete"
        >
          {t('shared_cancel_button')}
        </Button>
      </div>
    </div>
  );
};
